import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * AreaSidebar
 * Componente que renderiza a lista de Áreas no painel lateral do layout Master-Detail.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const AreaSidebar = ({
    areas = [],
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar áreas baseado na pesquisa local
    const filteredAreas = areas.filter((area) =>
        area.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear áreas para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredAreas.map((area) => ({
        id: area.id,
        label: area.name,
        description: `${area.width}m x ${area.length}m`,
        photoUrl: area.photoUrl || null,
        icon: "mdi-map-marker-path",
        badge: area.status !== GLOBAL_STATUS.ACTIVE ? "Inativo" : null,
        badgeVariant: area.status !== GLOBAL_STATUS.ACTIVE ? "muted" : null
    }));

    return (
        <NeoSideMenu
            title="Locais / Áreas"
            subtitle={`${areas.length} áreas cadastradas`}
            icon="mdi-map-marker-path"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const area = areas.find((a) => a.id === id);
                if (area) onSelect(area);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar área..."
                />
            }
        />
    );
};

AreaSidebar.propTypes = {
    areas: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default AreaSidebar;
